module.exports = __webpack_public_path__ + "static/realestate-5583806d6d015d016fdff865ea510f7d.jpg";